import { soundEditionV1_2Abi } from '../abi/sound-edition-v1_2.mjs';
import { BaseError, ContractFunctionZeroDataError } from 'viem';
import { interfaceIds } from '../constants.mjs';

async function isSoundEdition({
  editionAddress
}) {
  const { instance } = this;
  return instance.idempotentCachedCall(`is-sound-edition-${editionAddress}`, async () => {
    const client = await this.expectClient();
    try {
      return await client.readContract({
        abi: soundEditionV1_2Abi,
        address: editionAddress,
        functionName: "supportsInterface",
        args: [interfaceIds.ISoundEditionV1]
      });
    } catch (err) {
      if (err instanceof BaseError && err.walk((e) => e instanceof ContractFunctionZeroDataError)) {
        return false;
      }
      throw err;
    }
  });
}

export { isSoundEdition };
